import { useNavigate } from 'react-router-dom'
import { Plus } from 'lucide-react'
import PageContainer from '@/common/components/PageContainer'
import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { Button } from '@/common/ui/button'
import { Skeleton } from '@/common/ui/skeleton'
import { useQueryDepositStatus } from '../../api/hooks'
import { TemporaryDisableCard, ScheduleTable } from '../../components'

const DepositSchedulesPage = () => {
	const navigate = useNavigate()
	const { data: status, isLoading } = useQueryDepositStatus()

	return (
		<PageContainer>
			<div className="space-y-6 px-4 sm:px-0">
				<div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
					<Heading
						title="ตั้งค่าการฝากเงิน"
						description="จัดการตารางเวลาปิด-เปิดระบบฝากเงิน และการปิดชั่วคราว"
					/>
					<Button
						onClick={() =>
							navigate('/operator/transaction-settings/deposit/create')
						}
					>
						<Plus className="mr-2 h-4 w-4" />
						เพิ่มตารางเวลา
					</Button>
				</div>

				<Separator />

				{isLoading ? (
					<div className="space-y-6">
						<Skeleton className="h-48 w-full" />
						<Skeleton className="h-64 w-full" />
					</div>
				) : status ? (
					<div className="space-y-6">
						<TemporaryDisableCard
							type="deposit"
							temporaryDisable={status.temporaryDisable}
							isCurrentlyDisabled={status.isDisabled}
						/>

						<div className="space-y-4">
							<h3 className="text-lg font-medium">
								ตารางเวลาปิดฝากเงินประจำวัน
							</h3>
							<p className="text-sm text-muted-foreground">
								กำหนดช่วงเวลาที่ระบบจะปิดรับฝากเงินอัตโนมัติทุกวัน
							</p>
							<ScheduleTable
								schedules={status.schedules}
								type="deposit"
								currentActiveSchedule={status.currentActiveSchedule}
							/>
						</div>
					</div>
				) : (
					<div className="py-8 text-center text-muted-foreground">
						ไม่สามารถโหลดข้อมูลได้
					</div>
				)}
			</div>
		</PageContainer>
	)
}

export default DepositSchedulesPage
